import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minuteSeconds'
})
export class MinuteSecondsPipe implements PipeTransform {

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    const seconds = value - minutes * 60;
    return (minutes > 9 ? minutes : `0${minutes}`.slice(-2)) + ':' + ((seconds) > 9 ? seconds : `0${seconds}`.slice(-2));
  }

}
